import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Modal,
} from "react-native";
import React, { useState, useEffect } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { AntDesign } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../../_layout";
import { Menu, MenuItem } from "react-native-material-menu";
import { MaterialIcons } from "@expo/vector-icons";
import { useTranslation } from "react-i18next";

import { format } from "date-fns";

import Ionicons from "@expo/vector-icons/Ionicons";
import { ActivityIndicator } from "react-native-web";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";

const AddApplicationForm = observer(({ coach, isVisible, onClose }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [showingDeleteApplication, setShowingDeleteApplication] =
    useState(false);
  const deleteApplicationTitle = "deleteApplicationAlertTitle-string";
  const deleteApplicationText = "deleteApplicationAlertText-string";

  const HeaderButtons = () => {
    const Buttons = observer(({ bool }) => {
      const text = bool ? "save-string" : "cancel-string";
      const [isLoading, setIsLoading] = useState(false);
      const Save = async () => {
        console.log("PROVA 1");
        if (coach.canSaveApplicationForm && !isLoading) {
          console.log("PROVA 2");
          setIsLoading(true);
          await coach.EditApplicationForm();
          onClose();
          setIsLoading(false);
          console.log("PROVA 3");
        }
      };

      const Cancel = () => {
        if (!isLoading) {
          coach.resetAuxApplicationForm();
          onClose();
        }
      };

      const [isHovered, setIsHovered] = useState(false);

      return bool ? (
        <TouchableOpacity
          onPress={Save}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: Colors.bubbleColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: Colors.bubbleColor,
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
              opacity: !coach.canSaveApplicationForm
                ? 0.5
                : isHovered
                ? 0.7
                : 1,
            }}
          >
            {isLoading ? (
              <CustomActivityIndicator large={false} white={true} />
            ) : (
              <Text
                style={{
                  textAlignVertical: "center",
                  textAlign: "center",
                  color: Colors.whiteColor,
                }}
              >
                {t(text)}
              </Text>
            )}
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={Cancel}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: "red",
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
              marginHorizontal: 10,
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: isHovered ? "white" : Colors.redColor,
              }}
            >
              {t(text)}
            </Text>
          </View>
        </TouchableOpacity>
      );
    });
    return (
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          marginBottom: screenSize != "large" ? 8 : 16,
        }}
      >
        <Buttons bool={false} />
        <Buttons bool={true} />
      </View>
    );
  };

  const FormInfoSectionBlock = () => {
    const InfoQuestionRow = observer(({ question, index }) => {
      return (
        question && (
          <View
            style={{
              width: "100%",
              // borderWidth: 1,
              borderLeftWidth: 5,
              borderColor: "gray",
              borderLeftColor: Colors.bubbleColor,
              borderRadius: 5,
              paddingLeft: 8,
              marginTop: 10,
            }}
          >
            <Text
              style={{
                width: "100%",
                borderColor: Colors.borderColor,
                backgroundColor: Colors.whiteColor,
                color: Colors.blackColor,
                borderWidth: 0.1,
                padding: 8,
                borderRadius: 10,
                fontSize: screenSize === "large" ? 14 : 12,
              }}
            >
              {t(question)}
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginTop: 4,
                marginBottom: 2,
              }}
            >
              <Text style={{ marginBottom: 1 }}>
                {index === 1 ? t("notRequired-string") : t("required-string")}
              </Text>
              <View>
                <MaterialIcons
                  name="keyboard-arrow-up"
                  size={15}
                  color={Colors.blackColor}
                  style={{ paddingHorizontal: 4, marginBottom: -4 }}
                />
                <MaterialIcons
                  name="keyboard-arrow-down"
                  size={15}
                  color={Colors.blackColor}
                  style={{ paddingHorizontal: 4, marginTop: -4 }}
                />
              </View>
            </View>
          </View>
        )
      );
    });
    return (
      <View style={{ marginBottom: 15 }}>
        <Text
          style={{
            width: "100%",
            color: Colors.blackColor,
            paddingVertical: 4,
            fontWeight: "600",
          }}
        >
          {t("requiredInfo-string")}
        </Text>

        <InfoQuestionRow question={"name-string"} index={0} />
        <InfoQuestionRow question={"surname-string"} index={1} />
        <InfoQuestionRow question={"email-string"} index={2} />
        <InfoQuestionRow question={"hasCompetedQuestion-string"} index={3} />
      </View>
    );
  };

  const SectionBlock = observer(({ section, idx }) => {
    const QuestionRow = observer(({ question }) => {
      const [typeMenu, setTypeMenu] = useState(false);
      const showTypeMenu = () => setTypeMenu(true);

      const TypeMenu = () => {
        const MenuItemView = ({ idx }) => {
          const [isHovered, setIsHovered] = useState(false);

          return idx === 1 ? (
            <MenuItem
              onPress={() => {
                question.setProperty("isRequired", true);
                setTypeMenu(false);
              }}
              style={{ minWidth: 150 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("required-string")}
            </MenuItem>
          ) : (
            <MenuItem
              onPress={() => {
                question.setProperty("isRequired", false);
                setTypeMenu(false);
              }}
              style={{ minWidth: 150 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("notRequired-string")}
            </MenuItem>
          );
        };

        const [isHovered, setIsHovered] = useState(false);

        return (
          <Menu
            visible={typeMenu}
            anchor={
              <TouchableOpacity
                onPress={showTypeMenu}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 4,
                  marginBottom: 2,
                  opacity: isHovered ? 0.5 : 1,
                }}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Text style={{ marginBottom: 1 }}>
                  {question.typeLocalized(t)}
                </Text>
                <View>
                  <MaterialIcons
                    name="keyboard-arrow-up"
                    size={15}
                    color={Colors.blackColor}
                    style={{ paddingHorizontal: 4, marginBottom: -4 }}
                  />
                  <MaterialIcons
                    name="keyboard-arrow-down"
                    size={15}
                    color={Colors.blackColor}
                    style={{ paddingHorizontal: 4, marginTop: -4 }}
                  />
                </View>
              </TouchableOpacity>
            }
            style={GlobalStyles.menu}
            onRequestClose={() => setTypeMenu(false)}
          >
            <MenuItemView idx={1} />
            <MenuItemView idx={2} />
          </Menu>
        );
      };

      const DeleteQuestionButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() => question.section.deleteQuestion(question)}
            disabled={section.questions.length === 1}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Ionicons
              name={
                isHovered && section.questions.length > 1
                  ? "trash"
                  : "trash-outline"
              }
              size={20}
              color={"red"}
              style={{
                paddingLeft: 10,
                opacity: section.questions.length === 1 ? 0.5 : 1,
              }}
            />
          </TouchableOpacity>
        );
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        question && (
          <View
            style={{
              width: "100%",
              borderLeftWidth: 5,
              borderColor: "gray",
              borderLeftColor: Colors.bubbleColor,
              borderRadius: 5,
              paddingLeft: 8,
              marginTop: 10,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
              }}
            >
              <TextInput
                style={[
                  styles.questionInputStyle,
                  {
                    fontSize: screenSize === "large" ? 14 : 12,
                    borderColor: isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                  },
                ]}
                placeholder={t(
                  "questionPlaceholderFormApplicationsText-string"
                )}
                placeholderTextColor={Colors.grayColor}
                value={question.question}
                onChangeText={(text) => question.setProperty("question", text)}
                multiline={true}
                numberOfLines={screenSize === "large" ? 2 : 3}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
              <DeleteQuestionButton />
            </View>
            <TypeMenu />
          </View>
        )
      );
    });

    const DeleteSectionButton = () => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={() => coach.deleteApplicationSection(section)}
          style={{
            alignSelf: "center",
            flexDirection: "row",
            borderWidth: 1,
            borderColor: Colors.redColor,
            borderRadius: 12,
            paddingVertical: 6,
            paddingHorizontal: 8,
            alignItems: "center",
            backgroundColor: isHovered ? Colors.redColor : "transparent",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Text
            style={{
              fontSize: 12,
              color: isHovered ? Colors.whiteColor : Colors.redColor,
            }}
          >
            {t("deleteSection-string")}
          </Text>
        </TouchableOpacity>
      );
    };
    return (
      <View style={{ marginBottom: 15 }}>
        <View style={styles.sectionSeparator} />
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
          }}
        >
          <TextInput
            style={styles.sectionInputStyle}
            placeholder={t("nameOfSection-string")}
            placeholderTextColor={Colors.grayColor}
            value={section.name}
            onChangeText={(text) => section.setProperty("name", text)}
            maxLength={45}
          />
          {coach.applicationFormSections.length > 1 && <DeleteSectionButton />}
        </View>

        {section.questions &&
          section.questions.map((question, index) => (
            <QuestionRow question={question} key={index} />
          ))}
        <AddQuestionButton section={section} />
      </View>
    );
  });

  const AddQuestionButton = ({ section }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => section.addQuestion()}
        style={{
          alignSelf: "flex-start",
          marginTop: 10,
          flexDirection: "row",
          borderWidth: 1,
          borderColor: Colors.grayColor,
          borderRadius: 12,
          paddingVertical: 4,
          paddingHorizontal: 8,
          borderStyle: "dashed",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AntDesign name="plus" size={16} color={Colors.blackColor} />
        <Text
          style={{
            marginLeft: 4,
            fontWeight: isHovered ? "500" : "normal",
          }}
        >
          {t("addQuestion-string")}
        </Text>
      </TouchableOpacity>
    );
  };

  const AddSectionButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => coach.addApplicationSection()}
        style={{
          alignSelf: "center",
          marginVertical: 15,
          flexDirection: "row",
          borderWidth: 1,
          // borderColor: Colors.blackColor,
          borderRadius: 14,
          paddingVertical: 6,
          paddingHorizontal: 8,
          alignItems: "center",
          borderStyle: "dashed",
          borderColor: Colors.grayColor,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AntDesign name="plus" size={18} />
        <Text
          style={{
            marginLeft: 4,
            // fontWeight: "500",
            fontSize: 16,
            color: Colors.blackColor,
            fontWeight: isHovered ? "500" : "normal",
          }}
        >
          {t("addSection-string")}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <View style={GlobalStyles.touchableBackground}></View>
        <View
          style={[
            styles.modalView,
            {
              position: "absolute",
              height: "90%",
              padding: screenSize === "small" ? 8 : 24,
              width: "90%",
              maxWidth: 800,
              flex: 1,
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          <HeaderButtons />

          <ScrollView
            style={{
              flex: 1,
              // maxWidth: screenSize != "large" ? 500 : 1000,
              // minWidth: screenSize === "medium" ? 500 : 250,
              maxHeight: "100%",
              borderRadius: 16,
              borderWidth: 0.1,
              borderColor: Colors.borderColor,
              // justifyContent: "space-between",
              // alignItems: "center",
              padding: 10,
            }}
            contentContainerStyle={{ maxHeight: "100%" }}
            showsVerticalScrollIndicator={false}
          >
            <FormInfoSectionBlock />
            {coach.applicationFormSections &&
              coach.applicationFormSections.map((section, index) => (
                <SectionBlock section={section} idx={index} key={index} />
              ))}
            <AddSectionButton />
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  title: {
    fontSize: 28,
    fontWeight: "750",
  },
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  sectionSeparator: {
    width: "95%",
    backgroundColor: Colors.borderColor,
    height: 1,
    alignSelf: "center",
    marginBottom: 15,
  },
  sectionInputStyle: {
    width: "100%",
    color: Colors.blackColor,
    outlineStyle: "none",
    paddingVertical: 4,
    fontWeight: "600",
  },
  questionInputStyle: {
    width: "100%",
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 8,
    borderRadius: 10,
    outlineStyle: "none",
  },
  sectionDescSeparator: {
    width: "95%",
    backgroundColor: Colors.borderColor,
    height: 1,
    alignSelf: "center",
    marginVertical: 15,
  },
});

export default AddApplicationForm;
